'use client';

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@eliadmin/core/src/components/ui/form';
import { Input } from '@eliadmin/core/src/components/ui/input';
import { Textarea } from '@eliadmin/core/src/components/ui/textarea';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import type { Control, FieldPath } from 'react-hook-form';
import type { ContactFormValues } from './contact-form';

// Contact only needs text fields. Do not import the universal Field's calendars,
// phone-country picker, multi-select and dropdown implementations here.
export function Field({ control, name, label, required, type = 'text', className }: {
  control: Control<ContactFormValues, any, ContactFormValues>;
  name: FieldPath<ContactFormValues>;
  label: string;
  required?: boolean;
  type?: 'text' | 'email' | 'tel' | 'textarea';
  className?: { wrapper?: string; main?: string };
}) {
  const multiline = type === 'textarea';
  return <FormField control={control} name={name} render={({ field, fieldState }) => (
    <FormItem className={cn('relative w-full rounded-none', multiline ? 'min-h-[60px]' : 'min-h-[52px]', className?.wrapper)}>
      <FormLabel isRequired={false} className={cn(
        'absolute left-0 top-7 z-[1] m-0 -translate-y-1/2 cursor-text font-normal text-muted transition-all duration-100',
        field.value ? '!top-0 !translate-y-0 text-xs lg:text-sm' : 'text-sm sm:text-base',
        fieldState.error && 'text-destructive',
      )}>{label}{required ? ' *' : ''}</FormLabel>
      <FormControl>
        {multiline ? <Textarea {...field} value={String(field.value ?? '')} rows={8}
          className="w-full rounded-none bg-transparent px-0 pt-4 text-sm sm:text-base" /> :
          <Input {...field} value={String(field.value ?? '')} type={type} aria-required={required}
            autoComplete={name === 'name' ? 'name' : name === 'email' ? 'email' : name === 'phone' ? 'tel' : undefined}
            className={{ wrapper: 'h-[52px] rounded-none bg-transparent', main: cn('w-full rounded-none bg-transparent px-0 text-sm focus:ring-0 sm:text-base', className?.main) }} />}
      </FormControl>
      <FormMessage />
    </FormItem>
  )} />;
}
